<template>
  <transition name="slide-fade">
    <Card
        v-show="selectedTimer.id !== null && loading === false"
        class="p-col"
        style="width: 100%"
    >
      <template #title>
        <div class="p-d-flex p-jc-between">
          <div>
            <h3 class="p-m-0">
              <strong>{{ selectedTimer.alarmPointId }}</strong>
            </h3>
          </div>
          <div>
            <Button
                v-tooltip.bottom="_t('Delete')"
                class="p-button-rounded p-button-danger p-button-text"
                icon="pi pi-trash"
                @click="deleteAlarmTimerDialog = true;"
            />
          </div>
        </div>
      </template>
      <template #content>
        <TabView v-model:activeIndex="activeTab">
          <TabPanel :header="_t('menu.general')">
            <div class="p-grid">
              <div class="p-col-3 stripedBg" style="vertical-align: middle">
                <p>{{ _t("label_alarm_id") }}</p>
              </div>
              <div class="p-col-9 stripedBg" style="vertical-align: middle">
                <p>
                  <strong>{{ selectedTimer.alarmPointId }}</strong>
                </p>
              </div>

              <div class="p-col-3" style="vertical-align: middle">
                <p>ID</p>
              </div>
              <div class="p-col-9" style="vertical-align: middle">
                <p>
                  <strong>{{ selectedTimer.id }}</strong>
                </p>
              </div>

              <div class="p-col-3 stripedBg" style="vertical-align: middle">
                <p>System ID</p>
              </div>
              <div class="p-col-9 stripedBg" style="vertical-align: middle">
                <p>
                  <strong>{{ selectedTimer.systemId }}</strong>
                </p>
              </div>

              <div class="p-col-3" style="vertical-align: middle">
                <p>Created</p>
              </div>
              <div class="p-col-9" style="vertical-align: middle">
                <p>
                  <strong>{{ selectedTimer.created }}</strong>
                </p>
              </div>

              <div v-if="selectedTimer.cron" class="p-mt-6" style="flex: 1; max-width: 400px;">
                <Card class="cron-card">
                  <template #title>
                    Timer details
                  </template>
                  <template #content>
                    <div class="cron-card-row">
                      <div class="cron-label">Year:</div>
                      <div class="cron-value" style="color: #82B541">{{ parsedTextParts.year }}</div>
                    </div>
                    <div class="cron-card-row">
                      <div class="cron-label">Month:</div>
                      <div class="cron-value" style="color: #82B541">{{ parsedTextParts.month }}</div>
                    </div>
                    <div class="cron-card-row">
                      <div class="cron-label">Day:</div>
                      <div class="cron-value" style="color: #82B541">{{ parsedTextParts.day }}</div>
                    </div>
                    <div class="cron-card-row">
                      <div class="cron-label">Weekday:</div>
                      <div class="cron-value" style="color: #82B541">{{ parsedTextParts.weekday }}</div>
                    </div>
                    <div class="cron-card-row">
                      <div class="cron-label">Time:</div>
                      <div class="cron-value time" style="color: #82B541">
                        {{
                          parsedTextParts.hour.padStart(2, '0') + ':' + parsedTextParts.minute.padStart(2, '0') + ':' + parsedTextParts.second.padStart(2, '0')
                        }}
                      </div>
                    </div>

                    <Button
                        class="p-button-success p-mt-3"
                        :label="`${showCronRaw ? 'Hide' : 'Show'} original`"
                        :icon="showCronRaw ? 'pi pi-eye-slash' : 'pi pi-eye'"
                        @click="toggleCronVisible"
                    />

                    <div v-if="showCronRaw" class="p-mt-3"
                         style="border-top: 1px solid #ddd; padding-top: 10px; display: flex; justify-content: space-between;">
                      <div class="cron-label">Cron:</div>
                      <div class="cron-value" style="color: #82B541; font-family: monospace;">
                        {{ selectedTimer.cron }}
                      </div>
                    </div>
                  </template>
                </Card>
              </div>
            </div>
          </TabPanel>
          <TabPanel :header="_t('label_history')">
            <ReportsHistoryIndex
                :key="id"
                ref="reportHistory"
                :activeTab="30"
                :groupFilter="groupFilter"
                :startImmediately="true"
                filtersPrefix="all"
            ></ReportsHistoryIndex>
          </TabPanel>
        </TabView>
      </template>
    </Card>
  </transition>

  <Dialog v-model:visible="deleteAlarmTimerDialog">
    <template #header>
      <h3>{{ _t("Delete") }}</h3>
    </template>
    <p>
      <strong class="color-green">{{ selectedTimer.alarmPointId }}</strong>: {{ _t("label_delete_record") }}
    </p>
    <template #footer>
      <Button
          :label="_t('Cancel')"
          class="p-button-text"
          icon="pi pi-times"
          @click="deleteAlarmTimerDialog = false"
      />
      <Button
          :label="_t('Delete')"
          autofocus
          icon="pi pi-check"
          @click="deleteAlarmTimer"
      />
    </template>
  </Dialog>
</template>

<script>
import {deleteAlarmTimer} from "@/api/alarmTimer";
import ReportsHistoryIndex from "@/views/alarm_table/alarms/index.vue";
import {getList} from "@/api/list";

export default {
  name: "singleTimer",
  components: {ReportsHistoryIndex},
  props: {
    id: {
      type: String,
      default: null,
    },
    item: {
      type: Object,
    },
  },
  emits: ["callAlarmTimers"],
  data() {
    return {
      selectedTimer: {
        id: null,
        alarmPointId: null,
        systemId: null,
        cron: ''
      },
      loading: false,
      deleteAlarmTimerDialog: false,
      activeTab: 0,
      hoursDuration: 999999999,
      groupFilter: false,
      parsedCron: [],
      parsedText: '',
      parsedTextParts: {
        year: '',
        month: '',
        day: '',
        weekday: '',
        hour: '',
        minute: '',
        second: ''
      },
      showCronRaw: false,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.selectedTimer.id = this.$route.params.id;
    }
  },
  watch: {
    "$route.params.id"(value) {
      if (value) {
        this.selectedTimer.id = value;
        this.selectedTimer = this.item;
      } else {
        this.selectedTimer.id = null;
      }

      this.loadTabRelations();
      this.updateParsed();
    },
    item(value) {
      this.selectedTimer = value;

      if (value && value.cron) {
        this.updateParsed()
      }
    },
    activeTab() {
      this.loadTabRelations();
    }
  },
  methods: {
    toggleCronVisible() {
      this.showCronRaw = !this.showCronRaw;
    },
    updateParsed() {
      if (!this.selectedTimer.cron) return;

      const parts = this.selectedTimer.cron.trim().split(/\s+/);
      if (parts.length < 6 || parts.length > 7) {
        this.parsedTextParts = {};
        return;
      }

      if (parts.length === 6) parts.push('*');
      const [sec, min, hour, day, month, weekday, year] = parts;

      this.parsedTextParts = {
        second: sec,
        minute: min,
        hour: hour,
        day: (day === '*' ? 'Every day' : `${day}`),
        month: (month === '*' ? 'Every month' : this.describeMonthField(month)),
        weekday: (weekday === '*' ? 'Every weekday' : this.describeWeekdayField(weekday)),
        year: (year === '*' ? 'Every year' : year)
      };
    },
    describeMonthField(field) {
      const months = {
        '1': 'January',
        '2': 'February',
        '3': 'March',
        '4': 'April',
        '5': 'May',
        '6': 'June',
        '7': 'July',
        '8': 'August',
        '9': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December'
      };
      if (field.includes('-')) {
        const [start, end] = field.split('-');
        return `${months[start] || start} to ${months[end] || end}`;
      }
      if (field.includes(',')) {
        return field
            .split(',')
            .map(v => months[v] || v)
            .join(', ');
      }
      return months[field] || field;
    },

    describeWeekdayField(field) {
      const days = {
        '0': 'Sunday',
        '1': 'Monday',
        '2': 'Tuesday',
        '3': 'Wednesday',
        '4': 'Thursday',
        '5': 'Friday',
        '6': 'Saturday',
        '7': 'Sunday'
      };

      if (field.includes('-')) {
        const [start, end] = field.split('-');
        return `${days[start] || start} to ${days[end] || end}`;
      }

      if (field.includes(',')) {
        return field
            .split(',')
            .map(v => days[v] || v)
            .join(', ');
      }

      return days[field] || field;
    },
    deleteAlarmTimer() {
      deleteAlarmTimer(this.selectedTimer.id)
          .then(() => {
            this.selectedTimer = {
              id: null,
              alarmPointId: null,
              systemId: null,
            };
            this.deleteAlarmTimerDialog = false;
            this.$emit("callAlarmTimers");
          })
          .catch((error) => {
            let data = error.response.data
                ? error.response.data instanceof Object
                    ? error.response.data
                    : JSON.parse(error.response.data)
                : {};
            this.$root.showMessage(
                data.reason ? ": " + data.reason : "",
                "error"
            );
          });
    },
    loadTabRelations() {
      if (this.activeTab === 1) {
        getList('ALARMPOINT', 0, this.item.alarmPointId, 50, this.orgId, true, 'alarmPointId').then((response) => {
          const alarmPoint = response.data.list.filter((el => el.alarmPointId === this.item.alarmPointId))[0];

          if (this.$refs.reportHistory) {
            this.$refs.reportHistory.getHistoryByAlarmId(
                alarmPoint.id,
                {
                  alarmName: null,
                  alarmPointId: alarmPoint.alarmPointId,
                  statuses: [],
                  systemId: null,
                  triggeredBy: null,
                },
                {
                  hours: this.hoursDuration,
                  option: 'HOURS_DURATION'
                }
            )
          }
        })
      }
    }
  },
};
</script>

<style>
input {
  width: 100%;
  padding: 8px;
  margin: 10px 0;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
}

.cron-viewer p {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 1rem;
  color: #2c3e50;
  background: #f0f4f8;
  padding: 10px 15px;
  border-radius: 6px;
  max-width: 600px;
  margin: 15px auto 0;
  user-select: text;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.cron-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  max-width: 600px;
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.95rem;
}

.cron-card-row {
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
}

.cron-card-row:last-child {
  border-bottom: none;
}

.cron-label {
  width: 100px;
  font-weight: bold;
}

.cron-value {
  text-align: end;
}

.cron-value.time {
  font-family: monospace;
  color: #2c3e50;
}
</style>
